export default "__VITE_ASSET__6d0ed7de__"